import { Component, Input } from '@angular/core';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'checkout-optimization',
  templateUrl: './optimization.component.html',
  styleUrls: ['./optimization.component.scss'],
  standalone: false,
})
export class OptimizationComponent {
  @Input() settings: CheckoutSettings;
  @Input() formGroup: UntypedFormGroup;

  constructor() {}
}
